<template>
  <div>
    <vs-tabs :value="tabIndex">
      <vs-tab v-for="(tab, index) in tabList"
              :key="index"
              :label="tab.name"
              @click="moveTab(tab.boardSlug)"
      >
        <component :is="getComponent(tab.boardSlug)"/>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import AccidentReportIndex from '@/views/list/accident/AccidentReportIndex'
import AccidentReviewIndex from '@/views/list/accident/AccidentReviewIndex'
import AccidentStatisticsIndex from '@/views/list/accident/AccidentStatisticsIndex'
import SafetyCheck444Index from '@/views/list/safetycheck/SafetyCheck444Index'
import FireFightingSelfCheck from '@/views/list/safetycheck/FireFightingSelfCheck'
import ElectricalEquipmentCheck from '@/views/list/safetycheck/ElectricalEquipmentCheck'
import ElevatorSafetyCheck from '@/views/list/safetycheck/ElevatorSafetyCheck'
import WaterTankHygieneCheck from '@/views/list/safetycheck/WaterTankHygieneCheck'
import GasPressureCheck from '@/views/list/safetycheck/GasPressureCheck'
import PeriodicSafetyCheckBuilding from '@/views/list/safetycheck/PeriodicSafetyCheckBuilding'

export default {
  name: 'Index',
  components: {
    FireFightingSelfCheck,
    ElectricalEquipmentCheck,
    WaterTankHygieneCheck,
    GasPressureCheck,
    ElevatorSafetyCheck,
    PeriodicSafetyCheckBuilding,
    SafetyCheck444Index,
    AccidentStatisticsIndex,
    AccidentReviewIndex,
    AccidentReportIndex},
  data () {
    return {
    }
  },
  created () {
    const breadcrumb = [
      {title: 'Home'},
      {title: '안전점검'},
      {
        title: '안전점검',
        active: true
      }
    ]

    this.$store.commit('menu/UPDATE_PAGE_LIST', breadcrumb)
  },
  computed: {
    boardSlug () {
      return this.$route.params.boardSlug
    },
    tabList () {
      return [
        { name: '소방시설 자체 점검결과 보고서', boardSlug: 'firefighting_self_check'},
        { name: '전기시설 점검', boardSlug: 'electrical_equipment_check'},
        { name: '가스 압력상태 점검', boardSlug: 'gas_pressure_check'},
        { name: '승강기 안전 점검', boardSlug: 'elevator_safety_check'},
        { name: '저수조 위생 점검', boardSlug: 'water_tank_hygiene_check'},
        { name: '정기안전점검(건축물)', boardSlug: 'periodic_safety_check_building'},
      ]
    },
    tabIndex () {
      let i = 0
      for (i = 0; i < this.tabList.length; i++) {
        const tab = this.tabList[i]
        if (this.boardSlug === tab.boardSlug) {
          return i
        }
      }
      return 0
    }
  },
  methods:{
    moveTab (boardSlug) {
      this.$router.push({name:'list|approval_tab_list|safety_check', params:{boardSlug}})
    },
    getComponent (boardSlug) {
      if (boardSlug === 'firefighting_self_check') return 'FireFightingSelfCheck'
      else if (boardSlug === 'electrical_equipment_check') return 'ElectricalEquipmentCheck'
      else if (boardSlug === 'elevator_safety_check') return 'ElevatorSafetyCheck'
      else if (boardSlug === 'water_tank_hygiene_check') return 'WaterTankHygieneCheck'
      else if (boardSlug === 'gas_pressure_check') return 'GasPressureCheck'
      else if (boardSlug === 'periodic_safety_check_building') return 'PeriodicSafetyCheckBuilding'
      return 'SafetyCheck444Index'
    }
  }
}
</script>

<style scoped>

</style>
